/* ============================================================================
   Pet's Table — TS002: el contenido se libera con los resultados
   ----------------------------------------------------------------------------
   Lo pidió CRO el 10-sep-2026, y así está en el documento de Jorge: en su
   export todo lo que va de "Ingredientes" al FAQ vive dentro de un
   `<sc-if value="{{ showPlan }}">`. Mientras la persona arma su plan solo se ve
   "Comida fresca, lista en 4 pasos"; el resto aparece con el precio.

   POR QUÉ UN OBSERVADOR Y NO UN EVENTO
   pt-plan-builder.js no emite ni un evento propio: son ~40 globales y nada más.
   Pero sí deja una señal fiable y estable — enseña y esconde #priceBlock con
   `style.display`, y hay tres sitios del propio motor que ya se apoyan en eso.
   Aquí se lee, no se toca nada.

   RED DE SEGURIDAD
   Si este archivo no llegara a correr —bloqueado, error de red, un navegador
   viejo sin MutationObserver— el contenido NO puede quedarse escondido para
   siempre: pt-ts002.css lo revela si el <html> no lleva la marca de que este
   script arrancó. Ocultar contenido es exactamente el tipo de cosa que no
   puede depender de que un JS opcional funcione.
   ========================================================================== */
(function () {
  'use strict';

  var CLASE = 'pt-ts002-espera';

  function contenido() { return document.getElementById('ptContenido'); }

  function liberar() {
    var c = contenido();
    if (!c || !c.classList.contains(CLASE)) return false;
    c.classList.remove(CLASE);
    return true;
  }

  function hayPrecio() {
    var pb = document.getElementById('priceBlock');
    return !!pb && pb.style.display !== 'none';
  }

  function arrancar() {
    var c = contenido();
    if (!c) return false;

    /* La marca le dice al CSS que puede confiar en este script. Va en cuanto
       se confirma que el contenedor existe, no antes. */
    document.documentElement.setAttribute('data-pt-ts002', 'on');

    /* Puede que el precio ya esté a la vista: alguien que vuelve con el plan
       hecho, o una recarga con el estado guardado. */
    if (hayPrecio()) { liberar(); return true; }

    var pb = document.getElementById('priceBlock');
    if (!pb || typeof MutationObserver !== 'function') {
      /* Sin el bloque de precio o sin observador, no hay forma honesta de
         saber cuándo liberar: se libera y ya. Mejor enseñar de más que
         esconder contenido para siempre. */
      liberar();
      return true;
    }

    var obs = new MutationObserver(function () {
      if (hayPrecio() && liberar()) obs.disconnect();
    });
    obs.observe(pb, { attributes: true, attributeFilter: ['style'] });

    /* Cinturón: si en 10 minutos no pasó nada, se libera igual. Es el tiempo
       de alguien que deja la pestaña abierta, no el de un fallo. */
    setTimeout(function () { if (liberar()) obs.disconnect(); }, 600000);
    return true;
  }

  if (!arrancar()) {
    var n = 0;
    var t = setInterval(function () { if (arrancar() || ++n > 60) clearInterval(t); }, 250);
  }
})();
